import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { formatACFT, formatGallons } from '../../dwriUtils';

const DwriAnnualUseSection = ({ waterUses, loading, error }) => {
    if (error) return <p className="text-danger">Error loading annual use data.</p>;
    if (loading && waterUses.length === 0) return <p>Loading...</p>;

    const sorted = [...waterUses].sort((a, b) => b.historyYear - a.historyYear);

    return (
        <>
            <Row>
                <Col><span><b>Annual Use (ACFT)</b></span></Col>
            </Row>
            <div className="table-responsive">
                <Row className='dwri-table-header gx-0'>
                    <Col className='dwri-table-header-cell'><span><b>Year</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Residential</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Commercial</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Industrial</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Institutional</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Total (ACFT)</b></span></Col>
                </Row>
                {sorted.map((use, index) => (
                    <Row key={index} className={`dwri-table-row gx-0 ${index % 2 === 0 ? 'is-even' : 'is-odd'}`}>
                        <Col className='dwri-table-cell'><span>{use.historyYear}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatACFT(use.domesticUseACFT)}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatACFT(use.commercialUseACFT)}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatACFT(use.industrialUseACFT)}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatACFT(use.institutionalUseACFT)}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatACFT(use.totalUseACFT)}</span></Col>
                    </Row>
                ))}
            </div>
            <br />

            <Row>
                <Col><span><b>Annual Use (GAL)</b></span></Col>
            </Row>
            <div className="table-responsive">
                <Row className='dwri-table-header gx-0'>
                    <Col className='dwri-table-header-cell'><span><b>Year</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Residential</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Commercial</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Industrial</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Institutional</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Total (GAL)</b></span></Col>
                </Row>
                {sorted.map((use, index) => (
                    <Row key={index} className={`dwri-table-row gx-0 ${index % 2 === 0 ? 'is-even' : 'is-odd'}`}>
                        <Col className='dwri-table-cell'><span>{use.historyYear}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatGallons(use.domesticUseGallons)}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatGallons(use.commercialUseGallons)}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatGallons(use.industrialUseGallons)}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatGallons(use.institutionalUseGallons)}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatGallons(use.totalUseGallons)}</span></Col>
                    </Row>
                ))}
            </div>
            <br />

            <Row>
                <Col><span><b>Annual Use Totals (ACFT)</b></span></Col>
            </Row>
            <div className="table-responsive">
                <Row className='dwri-totals-table-header gx-0'>
                    <Col className='dwri-table-header-cell'><span><b>Year</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Total Retail Use (ACFT)</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Total From Sources (ACFT)</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Total Wholesale Sources (ACFT)</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Total Return Sources (ACFT)</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Non-Revenue %</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Non-Revenue (ACFT)</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Non-Revenue (GAL)</b></span></Col>
                </Row>
                {sorted.map((use, index) => (
                    <Row key={index} className={`dwri-totals-table-row gx-0 ${index % 2 === 0 ? 'is-even' : 'is-odd'}`}>
                        <Col className='dwri-table-cell'><span>{use.historyYear}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatACFT(use.totalUseACFT)}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatACFT(use.totalFromSourcesACFT)}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatACFT(use.totalWholesaleSourcesACFT)}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatACFT(use.totalReturnSourcesACFT)}</span></Col>
                        <Col className='dwri-table-cell'>
                            <span>{use.nonRevenuePercent != null ? `${formatACFT(use.nonRevenuePercent)}%` : ''}</span>
                        </Col>
                        <Col className='dwri-table-cell'><span>{formatACFT(use.nonRevenueACFT)}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatGallons(use.nonRevenueGallons)}</span></Col>
                    </Row>
                ))}
            </div>
            <br />
        </>
    );
};

export default DwriAnnualUseSection;
